const apiUrl =
  process.env.NODE_ENV === "development"
    ? "http://localhost:8000/node/"
    : process.env.REACT_APP_API_URL;

export const apiSignIn = async (username, password) => {
  try {
    const response = await fetch(`${apiUrl}users/sign-in`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ username, password }),
    });
    if (!response.ok) {
      return null;
    }
    const data = await response.json();
    if (!data) {
      return null;
    }
    return data;
  } catch (error) {
    console.error("Erro apiSignIn:", error);
    throw error;
  }
};

export const apiLoadUser = async (userId) => {
  try {
    const response = await fetch(`${apiUrl}users/${userId}`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    });
    if (!response.ok) {
      return null;
    }
    const data = await response.json();
    if (!data) {
      return null;
    }
    return data;
  } catch (error) {
    console.error("Erro apiLoadUser:", error);
    throw error;
  }
};

export const apiListUsers = async () => {
  try {
    const response = await fetch(`${apiUrl}users`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    });
    if (!response.ok) {
      return null;
    }
    const data = await response.json();
    if (!data) {
      return null;
    }
    return data.users;
  } catch (error) {
    console.error("Erro apiLoadUser:", error);
    throw error;
  }
};

export const apiSignUp = async (formData) => {
  try {
    const response = await fetch(`${apiUrl}users/sign-up`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(formData),
    });
    return response;
  } catch (error) {
    console.error("Erro apiSignUp:", error);
    throw error;
  }
};

export const apiUpdateUser = async (userId, data) => {
  try {
    const response = await fetch(`${apiUrl}users/update/${userId}`, {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(data),
    });
    return response;
  } catch (error) {
    console.error("Erro apiUpdateUser:", error);
    throw error;
  }
};

export const apiUpdatePassword = async (userId, newPassword) => {
  try {
    const response = await fetch(`${apiUrl}users/password/${userId}`, {
      method: "PATCH",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ newPassword }),
    });
    return response;
  } catch (error) {
    console.error("Erro apiUpdatePassword:", error);
    throw error;
  }
};

export const apiListServiceItems = async (serviceId, releaseId, uf) => {
  try {
    const response = await fetch(
      `${apiUrl}bases/serviceitems/${serviceId}/release/${releaseId}/state/${uf}`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
        },
      }
    );
    return await response.json();
  } catch (error) {
    console.error("Erro apiListServiceItems:", error);
    throw error;
  }
};

export const apiReleaseBase = async (releaseId, isReleased) => {
  try {
    const response = await fetch(`${apiUrl}bases/release/${releaseId}`, {
      method: "PATCH",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ isReleased }),
    });
    return response;
  } catch (error) {
    console.error("Erro apiReleaseBase:", error);
    throw error;
  }
};

export const apiDeleteRelease = async (releaseId) => {
  try {
    const response = await fetch(`${apiUrl}bases/release/${releaseId}`, {
      method: "DELETE",
      headers: {
        "Content-Type": "application/json",
      },
    });
    return response;
  } catch (error) {
    console.error("Erro apiDeleteRelease:", error);
    throw error;
  }
};

export const apiGetReleaseDetails = async (releaseId) => {
  try {
    const response = await fetch(`${apiUrl}bases/release/${releaseId}/stat`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    });
    return await response.json();
  } catch (error) {
    console.error("Erro apiGetReleaseDetails:", error);
    throw error;
  }
};

export const apiListAllBasesWithStats = async () => {
  try {
    const response = await fetch(`${apiUrl}bases/stats`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    });
    return await response.json();
  } catch (error) {
    console.error("Erro apiListAllBasesWithCounters:", error);
    throw error;
  }
};

export const apiListAllBases = async () => {
  try {
    const response = await fetch(`${apiUrl}bases`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    });
    return await response.json();
  } catch (error) {
    console.error("Erro apiListAllBases:", error);
    throw error;
  }
};

export const apiListBases = async (selectedPraca) => {
  try {
    const response = await fetch(`${apiUrl}bases/uf/${selectedPraca}`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    });
    return await response.json();
  } catch (error) {
    console.error("Erro apiListBases:", error);
    throw error;
  }
};

export const apiListReleases = async (selectedBase) => {
  try {
    const response = await fetch(`${apiUrl}bases/release/${selectedBase}`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    });
    return await response.json();
  } catch (error) {
    console.error("Erro apiListReleases:", error);
    throw error;
  }
};

export const apiListCostGroups = async (releaseId, hasText, hasNotText) => {
  try {
    const response = await fetch(
      `${apiUrl}bases/costgroups/release/${releaseId}?has=${hasText}&hasNot=${hasNotText}`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
        },
      }
    );
    return await response.json();
  } catch (error) {
    console.error("Erro apiListCostGroups:", error);
    throw error;
  }
};

export const apiListResults = async (
  pracaId,
  costGroupId,
  has,
  hasNot,
  userId
) => {
  try {
    const response = await fetch(
      `${apiUrl}bases/costgroup/${costGroupId}/state/${pracaId}?has=${has}&hasNot=${hasNot}`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
        },
      }
    );

    return await response.json();
  } catch (error) {
    console.error("Erro apiListResults:", error);
    throw error;
  }
};

export const apiExportBases = async (releaseId, uf, data, signal) => {
  try {
    const response = await fetch(
      `${apiUrl}bases/export/release/${releaseId}/uf/${uf}`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(data),
        signal,
      }
    );
    return response;
  } catch (error) {
    console.error("Erro apiExportBases:", error);
    throw error;
  }
};

export const apiRecoveryCode = async (email) => {
  try {
    const response = await fetch(`${apiUrl}users/recovery`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ email }),
    });
    return response;
  } catch (error) {
    console.error("Erro apiRecoveryCode:", error);
    throw error;
  }
};

export const apiRecoveryPass = async (email, code, password) => {
  try {
    const response = await fetch(`${apiUrl}users/recovery`, {
      method: "PATCH",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ email, code, password }),
    });
    return await response.json();
  } catch (error) {
    console.error("Erro apiRecoveryPass:", error);
    throw error;
  }
};

export const apiUpdateLgpd = async (userId, data) => {
  try {
    const date = !data ? new Date().toISOString() : null;

    const response = await fetch(`${apiUrl}users/${userId}`, {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ lgpd: date }),
    });
    if (response && response.ok) {
      return date;
    }
    return null;
  } catch (error) {
    console.error("Erro apiUpdateLgpd:", error);
    throw error;
  }
};

export const apiCreatePayment = async (data) => {
  try {
    const response = await fetch(`${apiUrl}users/purchase`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(data),
    });

    return response;
  } catch (error) {
    console.error("Erro apiCreatePayment:", error);
    throw error;
  }
};

export const apiListTaxes = async (releaseId, pracaId) => {
  try {
    const response = await fetch(
      `${apiUrl}taxes/release/${releaseId}/state/${pracaId}`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
        },
      }
    );
    return await response.json();
  } catch (error) {
    console.error("Erro apiListTaxes:", error);
    throw error;
  }
};
